// Pure utility functions - no React dependencies

/**
 * Positive integer or null.
 * API sometimes returns total:0, pages:0 with real data, so 0/NaN treated as unknown.
 */
export function positiveIntOrNull(v) {
  if (v == null || v === "") return null;
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.floor(n);
}

/**
 * Normalize admin announcements list.
 * Supports root fields like { items, total, page, size, pages } and nested pagination/meta.
 */
export function parseAnnouncementsListResponse(raw, limit, currentPage) {
  const items =
    raw?.items ??
    raw?.announcements ??
    raw?.data ??
    (Array.isArray(raw) ? raw : []);

  const safeItems = Array.isArray(items) ? items : [];
  const pag = raw?.pagination ?? raw?.meta ?? {};

  const totalItems = positiveIntOrNull(
    raw?.total ??
      pag?.total ??
      raw?.total_count ??
      pag?.total_count ??
      raw?.count
  );

  let totalPages = positiveIntOrNull(
    raw?.pages ?? pag?.pages ?? raw?.total_pages ?? pag?.total_pages
  );

  if (totalPages == null && totalItems != null && limit > 0) {
    totalPages = Math.max(1, Math.ceil(totalItems / limit));
  } else if (totalPages == null) {
    totalPages = safeItems.length < limit ? currentPage : currentPage + 1;
    totalPages = Math.max(1, totalPages);
  }

  if (totalItems != null && limit > 0) {
    totalPages = Math.max(totalPages, Math.ceil(totalItems / limit));
  }

  const knownLastPage =
    totalItems != null && limit > 0 ? Math.max(1, Math.ceil(totalItems / limit)) : null;
  if (
    safeItems.length === limit &&
    (knownLastPage == null || currentPage < knownLastPage)
  ) {
    totalPages = Math.max(totalPages, currentPage + 1);
  }

  return { items: safeItems, totalPages, totalItems };
}

/**
 * Format price for listing display.
 * Бағасы жоқ (келісімді баға — negotiable) болса «Договорная». Ескі бэкенд бос бағаны
 * "None" мәтіні ретінде қайтаратын — оны да бос деп санаймыз.
 */
export function formatListingPrice(value, currency, negotiable = false) {
  const empty = value == null || value === "" || value === "None";
  if (empty) return negotiable ? "Договорная" : "—";
  const n = Number(value);
  const formatted = Number.isFinite(n)
    ? n.toLocaleString("ru-RU", { maximumFractionDigits: 0 })
    : String(value ?? "");
  const cur = currency != null ? String(currency) : "";
  return [formatted, cur].filter(Boolean).join(" ");
}

/**
 * Up to `max` page indices centered on current page.
 */
export function visiblePageIndices(page, totalPages, max = 5) {
  if (totalPages <= max) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  let start = Math.max(1, page - Math.floor(max / 2));
  let end = start + max - 1;
  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - max + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}